module.exports = __webpack_public_path__ + "img/fi-water-side-rest-1200x790.b4727363.jpg";